import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Cabserviceinnavimumbai() {



  const cardData = {
    keyword: " Cab Service in Navi Mumbai ",


"headingDescription": "Royal Route Cab offers reliable and comfortable cab services in Navi Mumbai, providing safe, affordable, and 24/7 travel solutions for local rides, airport transfers, corporate travel, and outstation journeys. Whether you are commuting within Navi Mumbai, traveling to Mumbai, or planning long-distance trips, our professional drivers and well-maintained vehicles ensure a smooth and stress-free journey. We provide quick pickups, transparent pricing, and easy booking options with no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With 24/7 customer support and convenient booking, Royal Route Cab is your trusted choice for cab service in Navi Mumbai.",

"topPlaces": [
  {
    "title": "Navi Mumbai to Lonavala",
    "description": "Lonavala is one of the most popular outstation destinations from Navi Mumbai, known for its lush green valleys, waterfalls, and scenic viewpoints. Attractions like Bhushi Dam, Tiger’s Leap, and Rajmachi Point make it a perfect weekend getaway."
  },
  {
    "title": "Navi Mumbai to Pune",
    "description": "Pune is a major cultural and IT hub near Navi Mumbai, offering attractions like Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, and vibrant food streets. It is ideal for both leisure and business travel."
  },
  {
    "title": "Navi Mumbai to Nashik",
    "description": "Nashik is a famous religious and wine tourism destination known for Trimbakeshwar Temple, Sula Vineyards, Panchavati, and Godavari Ghats. It is a popular route for pilgrims and weekend travelers."
  },
  {
    "title": "Navi Mumbai to Shirdi",
    "description": "Shirdi is one of the most visited pilgrimage destinations in India, home to the Sai Baba Temple. Travelers from Navi Mumbai often book outstation cabs for a comfortable darshan trip and return journey."
  },
  {
    "title": "Navi Mumbai to Mahabaleshwar",
    "description": "Mahabaleshwar is a beautiful hill station known for strawberry farms, scenic viewpoints, cool weather, and attractions like Venna Lake, Arthur’s Seat, and Wilson Point. It is ideal for family vacations."
  },
  {
    "title": "Navi Mumbai to Matheran",
    "description": "Matheran is a peaceful eco-friendly hill station where vehicles are restricted, offering toy train rides, forest trails, and panoramic viewpoints. It is one of the closest weekend getaways from Navi Mumbai."
  },
  {
    "title": "Navi Mumbai to Alibaug",
    "description": "Alibaug is a coastal getaway known for its clean beaches, sea forts, and relaxing atmosphere. It is a popular destination for short trips, beach outings, and family vacations."
  },
  {
    "title": "Navi Mumbai to Igatpuri",
    "description": "Igatpuri is a scenic hill station surrounded by the Sahyadri ranges, famous for waterfalls, greenery, and peaceful surroundings. It is especially popular during monsoon season trips."
  },
  {
    "title": "Navi Mumbai to Aurangabad",
    "description": "Aurangabad is known for UNESCO World Heritage Sites like Ajanta and Ellora Caves, along with historical landmarks such as Bibi Ka Maqbara and Daulatabad Fort. It is ideal for heritage tourism."
  },
  {
    "title": "Navi Mumbai to Goa",
    "description": "Goa is a top long-distance outstation destination from Navi Mumbai, famous for beaches, nightlife, water sports, and Portuguese culture. It is ideal for vacations, group trips, and holidays."
  }
],






services: [
  {
    name: "Cab Service in Navi Mumbai",
    description: "Cab service in Navi Mumbai offers reliable and convenient transportation for local travel, airport transfers, and outstation trips. With well-maintained vehicles and professional drivers, this service ensures comfort and safety. Ideal for families, office commuters, and travelers. Flexible booking options enhance convenience. It guarantees a smooth travel experience."
  },
  {
    name: "Taxi Service in Navi Mumbai",
    description: "Taxi service in Navi Mumbai provides easy and accessible travel solutions across the city and nearby areas. This service is perfect for daily commuting and short trips. Vehicles are clean and driven by experienced chauffeurs. Flexible timings make travel convenient. It ensures a comfortable journey."
  },
  {
    name: "Navi Mumbai Cab Booking",
    description: "Navi Mumbai cab booking allows customers to reserve rides quickly with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning for both local and outstation journeys."
  },
  {
    name: "Navi Mumbai Taxi Booking Online",
    description: "Navi Mumbai taxi booking online provides a quick and convenient way to book taxis from anywhere. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Local Cab Service Navi Mumbai",
    description: "Local cab service Navi Mumbai is designed for short-distance travel within the city. This service is ideal for office commutes, shopping trips, and daily errands. Quick availability and flexible booking make it convenient. It ensures smooth city travel."
  },
  {
    name: "Outstation Cab Service Navi Mumbai",
    description: "Outstation cab service Navi Mumbai offers comfortable travel to nearby cities and long-distance destinations. This service includes one way and round trip options. Vehicles are maintained for highway travel. It ensures a safe and enjoyable journey."
  },
  {
    name: "Airport Cab Service Navi Mumbai",
    description: "Airport cab service Navi Mumbai provides seamless pickup and drop to Mumbai airport. This service ensures timely arrival and departure for flights. Professional drivers and clean vehicles enhance comfort. Ideal for business travelers and tourists. It guarantees a stress-free airport transfer."
  },
  {
    name: "Cheap Cab Service Navi Mumbai",
    description: "Cheap cab service Navi Mumbai offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical vehicle options are available for daily use. Transparent pricing ensures no hidden charges. It ensures affordable travel."
  },
  {
    name: "Best Taxi Service Navi Mumbai",
    description: "Best taxi service Navi Mumbai ensures premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Suitable for all travel needs. It guarantees a reliable and comfortable journey."
  },
  {
    name: "24x7 Cab Service Navi Mumbai",
    description: "24x7 cab service Navi Mumbai ensures round-the-clock availability for all travel needs. This service is ideal for late-night rides, early morning airport transfers, and emergency travel. Quick booking and reliable drivers ensure timely service. It guarantees convenience anytime."
  },
  {
    name: "Private Cab Service Navi Mumbai",
    description: "Private cab service Navi Mumbai offers personalized travel with exclusive vehicle usage. Travelers can customize routes and travel timings based on their needs. Ideal for families and business travelers. It ensures a comfortable and relaxed journey."
  },
  {
    name: "Sedan Cab Service Navi Mumbai",
    description: "Sedan cab service Navi Mumbai is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and good mileage. Suitable for local and airport travel. Professional drivers ensure safe travel. It ensures a pleasant journey."
  },
  {
    name: "SUV Cab Service Navi Mumbai",
    description: "SUV cab service Navi Mumbai provides spacious and comfortable travel for families and groups. SUVs offer extra space and better performance for long journeys. Suitable for city and outstation travel. It ensures a comfortable experience."
  },
  {
    name: "Innova Cab Service Navi Mumbai",
    description: "Innova cab service Navi Mumbai is perfect for group travel and corporate trips. The vehicle offers spacious seating and premium comfort. Ideal for long-distance journeys. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Ertiga Cab Service Navi Mumbai",
    description: "Ertiga cab service Navi Mumbai is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. Ideal for local and outstation travel. It ensures a smooth journey."
  },
  {
    name: "Reliable Cab Service Navi Mumbai",
    description: "Reliable cab service Navi Mumbai ensures consistent and dependable travel with well-maintained vehicles and professional drivers. This service focuses on punctuality and customer satisfaction. Suitable for daily commuting and long-distance travel. It guarantees a hassle-free experience."
  }
],

tableData: [
  ["Cab Service in Navi Mumbai", "Taxi Service in Navi Mumbai"],
  ["Navi Mumbai Cab Booking", "Navi Mumbai Taxi Booking Online"],
  ["Local Cab Service Navi Mumbai", "Outstation Cab Service Navi Mumbai"],
  ["Airport Cab Service Navi Mumbai", "Cheap Cab Service Navi Mumbai"],
  ["Best Taxi Service Navi Mumbai", "24x7 Cab Service Navi Mumbai"],
  ["Private Cab Service Navi Mumbai", "Sedan Cab Service Navi Mumbai"],
  ["SUV Cab Service Navi Mumbai", "Innova Cab Service Navi Mumbai"],
  ["Ertiga Cab Service Navi Mumbai", "Reliable Cab Service Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Navi Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers dependable cab service in Navi Mumbai for local travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Our drivers are well-trained and experienced in Navi Mumbai and Mumbai routes, ensuring safe and timely travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear and upfront pricing with no hidden costs, ensuring complete transparency in every booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai cab service operates round the clock, allowing you to book a cab anytime for daily or urgent travel needs."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable ride experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "We provide cab services for local Navi Mumbai travel, Mumbai airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for all travel needs."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for reliable and punctual cab service in Navi Mumbai."
  }
]

};

const faqData = [
  { question: "Do you provide cab service in Navi Mumbai?", answer: "Yes, Royal Route Cabs offers reliable cab services across Navi Mumbai for local and outstation travel." },
  { question: "Is cab service available 24 hours in Navi Mumbai?", answer: "Yes, our Navi Mumbai cab service operates 24/7." },
  { question: "Do you provide airport cab service from Navi Mumbai?", answer: "Yes, we offer Mumbai airport pickup and drop services from Navi Mumbai." },
  { question: "Which areas in Navi Mumbai do you cover?", answer: "We cover all areas including Vashi, Nerul, Belapur, Kharghar, Panvel, and nearby locations." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a cab for outstation travel?", answer: "Yes, we provide outstation cab services from Navi Mumbai to multiple destinations." },
  { question: "Is pricing transparent?", answer: "Yes, we provide clear pricing with no hidden charges." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Navi Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for peak hours and long-distance travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Patil",
    feedback: "Cab service in Navi Mumbai with Royal Route Cabs was very reliable and smooth. The driver arrived on time and the ride was comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshmukh",
    feedback: "Great experience with cab service in Navi Mumbai. The vehicle was clean, service was prompt, and the overall journey felt safe and well-managed.",
    rating: 5
  }
];














  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Navi Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/cab-service-in-navi-mumbai.jpg", // replace if needed
  "description": "Book cab service in Navi Mumbai with Royal Route Cabs for safe, reliable, and affordable travel. Available for local, airport, and outstation trips with sedan, SUV, Innova, and luxury cars. 24x7 taxi service with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "499", // starting local fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/cab-service-in-navi-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Cab Service in Navi Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book cab service in Navi Mumbai with Royal Route Cabs. 24x7 local, airport, and outstation taxi service with sedan, SUV, Innova & luxury cars. Safe and affordable rides."
  />

  <meta
    name="keywords"
    content="cab service in navi mumbai, taxi service in navi mumbai, navi mumbai cab booking, navi mumbai taxi booking online, local cab service navi mumbai, outstation cab service navi mumbai, airport cab service navi mumbai, cheap cab service navi mumbai, best taxi service navi mumbai, 24x7 cab service navi mumbai, private cab service navi mumbai, sedan cab service navi mumbai, suv cab service navi mumbai, innova cab service navi mumbai, ertiga cab service navi mumbai, reliable cab service navi mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinnavimumbai;